import clsx from 'clsx'
import { Button } from 'component/Button/Button'
import { Space } from 'component/Space/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { useEffect, useState } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import { Item } from 'type/Item'
import css from './ComboButton.module.scss'

interface ComboButtonProps {
  item: Item
  className?: string
}

export const ComboButton = observer(({ item, className }: ComboButtonProps) => {
  const [isClient, setIsClient] = useState(false)
  const demo = useDemo()
  const { mobile } = ui.window

  useEffect(() => {
    setIsClient(true)
  }, [])

  const onComboAdd = useLatestCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()
      event.stopPropagation()
      comboCartStore.toggleItem(item)
    },
  )

  const checked = isClient ? comboCartStore.isItemInCart(item.item_id) : false

  if (!demo.canCombine(item)) {
    return null
  }

  return (
    <Button
      xl
      compact
      text
      invert={checked}
      action={onComboAdd}
      className={clsx(
        css.comboButton,
        mobile && !checked && css.mobile,
        className,
      )}
    >
      <Space gap={6}>
        <Icon name="shopping_bag" size={16} />
      </Space>
    </Button>
  )
})
